<template>
    <page>
        <div class="shadow-25 col-4">
            <v-header :title="'4002 - ' + $T('no relatable ad group')" icon="error"/>
            <card title-inverted
                  title-color="primary"
                  footer-color="white"
                  width="100%">

                <div class="q-pa-xl text-center">
                    {{ $T('the user has no AD group mapped in the app.') }}
                </div>
            </card>
        </div>
    </page>
</template>

<script>
    export default {
        layout: 'basic',
        name: 'NoLendingPoint'
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/errors/4002.vue